








































































































import { Component, Mixins, Prop } from "vue-property-decorator";
import { mapState } from "vuex";

// Mixins
import RequestPromises from "@/mixins/requestPromises";

// Enums/Data
import { DataModules } from "@/store/modules/data";
import {
  CustomFieldsMajorTypes,
  CustomFieldsTypes
} from "@/data/enums/customFields";
import { CustomFields as CustomFieldTypes } from "@/data/status";

// Types
import { ICustomField } from "@/models/brands";
import { IState } from "@/store";
import { ActionTypes } from "@/data/enums";

@Component({
  computed: {
    ...mapState({
      customFields(state: IState, getters) {
        return getters[`data/listArray`]({
          storeModule: this.dataModule
        });
      }
    })
  }
})
export default class ManageCustomFields extends Mixins(RequestPromises) {
  // Getters
  public customFields!: ICustomField[];

  // Props
  @Prop({ default: CustomFieldsMajorTypes.CLIENT })
  public customFieldsType!: string;

  // Variables
  public isLoading = true;
  public isReloading = false;
  public requestError = false;

  public customFieldTypes: any = this.$_.clone(CustomFieldTypes);

  public created() {
    this.loadData();
  }

  public get dataModule() {
    return this.isClientCustomField
      ? DataModules.CUSTOM_FIELDS_CLIENTS
      : DataModules.CUSTOM_FIELDS_BASKET;
  }

  public get isClientCustomField() {
    return this.customFieldsType === CustomFieldsMajorTypes.CLIENT;
  }

  public async loadData() {
    try {
      await this.getCustomFields();
      this.requestError = false;
    } catch (error) {
      this.$buefy.toast.open({
        message: this.$_.get(error, "message"),
        type: "is-danger"
      });
      this.requestError = true;
    }
    this.isLoading = false;
    this.isReloading = false;
  }

  public reloadData() {
    this.isReloading = true;
    this.loadData();
  }

  public getCustomFields(forceReload = false) {
    return this.$store.dispatch(`data/${this.dataModule}/list`, {
      params: {
        limit: 0,
        order: "order"
      },
      ignoreStored: forceReload,
      vm: this
    });
  }

  public get actionTypes() {
    return ActionTypes;
  }

  public getTypeName(fieldType: CustomFieldsTypes) {
    const typeName: string = this.$_.get(
      this.$_.find(this.customFieldTypes, type => {
        return type.key === fieldType;
      }),
      "value",
      ""
    );
    return this.$_.isEmpty(typeName) ? typeName : this.$t("_." + typeName);
  }

  public async deleteCustomField(fieldId: ICustomField["id"]) {
    const confirm = await this.$store.dispatch("ui/open/confirmModal", {
      config: {
        props: {
          autoClose: false,
          confirmButtonText: this.$t("_action.delete"),
          message: this.$t("_sentence.delete_confirmation", {
            object: (this.$t("_.custom_field") as string).toLowerCase()
          })
        },
        events: {
          confirmed: async () => {
            try {
              await this.onDeleteConfirmed(fieldId);
              this.$buefy.toast.open({
                message: this.$t("_.object_successfully_removed", {
                  object: this.$t("_.custom_field")
                }) as string
              });
            } catch (error) {
              this.$store.dispatch("api/handleError", error);
            }
            confirm.close();
          }
        }
      }
    });
  }

  public onDeleteConfirmed(customFieldId: ICustomField["id"]): Promise<any> {
    return this.$store.dispatch(`data/${this.dataModule}/remove`, {
      id: customFieldId
    });
  }

  public reorder(newOrder: number[]) {
    return this.$store.dispatch(`data/${this.dataModule}/reorder`, {
      vm: this,
      data: {
        field_ids: newOrder
      }
    });
  }

  public refreshOrder() {
    return this.getCustomFields(true);
  }

  public get i18n() {
    return {
      noResultsTitle: this.isClientCustomField
        ? this.$t("_.no_client_custom_fields")
        : this.$t("_.no_basket_custom_fields"),
      noResultsMessage: this.isClientCustomField
        ? this.$t("_sentence.no_client_custom_fields_msg")
        : this.$t("_sentence.no_basket_custom_fields_msg")
    };
  }

  public openManageCustomFieldModal(
    actionType: string = ActionTypes.CREATE,
    customFieldId: ICustomField["id"]
  ) {
    if (this.canCreateCustomField) {
      this.$store.dispatch(
        `data/${DataModules.CUSTOM_FIELDS}/openManageCustomFieldModal`,
        {
          props: {
            customFieldId: customFieldId ? customFieldId : null,
            customFieldType: this.customFieldsType,
            actionType: actionType
          }
        }
      );
    }
  }

  public get canCreateCustomField() {
    return this.isClientCustomField
      ? this.$userCan("create_client_field")
      : this.$userCan("create_basket_field");
  }

  public get canReorderCustomField() {
    return this.isClientCustomField
      ? this.$userCan("sync_client_field_order")
      : this.$userCan("update_basket_field_position");
  }

  public beforeDestroy() {
    this.$store.dispatch("data/binList", {
      storeModule: this.dataModule,
      vm: this
    });
  }
}
